import { titleCase } from 'title-case'
import { useSnapshot } from 'valtio'
import { options } from '../optionsStorage'
import { OptionsGroupType, guiOptionsScheme } from '../optionsGuiScheme'
import { optionsMeta } from '../defaultOptions'
import { miscUiState } from '../globalState'
import { FR_OPTION_IDS } from '../locale/fr'
import OptionsItems, { OptionMeta } from './OptionsItems'

export const optionValueToType = (optionValue: any, optionKey: string) => {
  // Check if option has possible values in optionsMeta (enum = toggle)
  const meta = optionsMeta[optionKey as keyof typeof optionsMeta]
  if (typeof optionValue === 'boolean' || (meta?.possibleValues && meta.possibleValues.length > 0)) return 'toggle'
  if (typeof optionValue === 'number') return 'slider'
  if (typeof optionValue === 'string') return 'element'
}

const finalItemsScheme: Record<keyof typeof guiOptionsScheme, OptionMeta[]> = Object.fromEntries(Object.entries(guiOptionsScheme).map(([groupName, optionsArr]) => {
  return [groupName, optionsArr.flatMap((optionsObj) => {
    return Object.entries(optionsObj).map(([optionKey, metaMerge]) => {
      const optionValue = options[optionKey]

      const type = optionValueToType(optionValue, optionKey)
      const meta: OptionMeta = {
        id: optionKey === 'custom' ? undefined : optionKey,
        type,
        // todo I don't like the whole idea of custom. Why it is even here?
        ...optionKey === 'custom' ? {
          type: 'element',
          render: metaMerge
        } : {
          ...metaMerge,
        }
      }
      return meta
    })
  })]
}))

const GROUP_TITLES_FR: Partial<Record<OptionsGroupType, string>> = {
  main: 'Paramètres',
  render: 'Graphismes',
  interface: 'Interface',
  controls: 'Contrôles',
  sound: 'Son',
  advanced: 'Avancé',
  VR: 'Réalité virtuelle',
  inventory: 'Inventaire',
  'export-import': 'Export / import',
}

export default ({ group, backButtonAction }: { group: OptionsGroupType, backButtonAction? }) => {
  const { appConfig } = useSnapshot(miscUiState)
  const items = finalItemsScheme[group].map(item => {
    if (appConfig?.locale !== 'fr' || !item.id) return item
    const fr = FR_OPTION_IDS[item.id]
    return fr ? { ...item, text: fr } : item
  })

  const title = appConfig?.locale === 'fr'
    ? (GROUP_TITLES_FR[group] ?? `${titleCase(group)}`)
    : (group === 'main' ? 'Settings' : `${titleCase(group)} Settings`)
  return <OptionsItems items={items} title={title} backButtonAction={backButtonAction} />
}
